export enum Team {
  Player = "Player",
  Enemy = "Enemy"
}